<script setup lang="ts">
interface Props {
  crumbs: {
    title: string
    html_path: string
  }[]
  currentTitle: string
}

const props = defineProps<Props>()
</script>

<template>
  <div class="container hidden md:block md:py-6">
    <ul
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
    >
      <li
        v-for="(crumb, index) in props.crumbs"
        :key="`breadcrumb_${index}`"
        class="inline-flex items-center text-sm after:px-2 after:content-['/']"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <NuxtLink
          :to="crumb.html_path"
          class="hover:underline focus-visible:z-10 focus-visible:rounded focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          itemprop="item"
        >
          <span itemprop="name">
            {{ crumb.title }}
          </span>
          <meta
            itemprop="position"
            :content="index.toString()"
          >
        </NuxtLink>
      </li>
      <li class="inline-flex items-center text-sm">
        <span class="font-semibold">
          {{ props.currentTitle }}
        </span>
      </li>
    </ul>
  </div>
</template>
